/* Dreavaya search (WS4): suggestions + N° lookup; no JS → plain submit. */
(function () {
  const D = document, CFG = window.DV_CFG || {}, root = CFG.root || '/', OP = ' role="option"';
  let S = {}, dead = 0; try { S = JSON.parse(D.getElementById('DvSearchData').textContent); } catch (e) {}
  const T = S.t || {}, N = S.names || {};  // HTML-escaped by t
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => '&#' + c.charCodeAt(0) + ';');
  const cat = () => window.DV?.cat;
  const img = (u) => `<img src="${esc(u && u.replace(/width=\d+|$/, (m) => (m ? '' : '&') + 'width=96'))}" alt="" width="48" height="48" loading="lazy">`;
  const money = (c) => (window.DV?.cart?.fmt(c) || '').replace(/[.,]00(?!\d)/, '');
  const ticket = (it, a = '') => `<a class="dv-tk" href="${esc(it.u)}"${a}>${img(it.i)}<span class="dv-vh">${T.code.replace('%C%', it.c)}</span><span class="dv-mono" aria-hidden="true">N° ${it.c}</span><span class="dv-tk__t">${esc(it.t)}</span></a>`;
  const group = (k, rows) => (rows ? `<div role="group" aria-label="${T[k]}"><div class="dv-sug__h" aria-hidden="true">${T[k]}</div>${rows}</div>` : '');
  // x = a dvjson item
  const row = (x) => `<a href="${esc(x.u)}"${OP}>${img(x.i)}<span class="dv-sug__t"><b>${esc(x.t)}</b><small>${[x.c && `<span class="dv-mono">N° ${x.c}</span>`, N[x.s]].filter(Boolean).join(' · ')}</small></span><span class="dv-sug__pr">${money(x.pr)}</span></a>`;
  const fromP = (p) => {
    const st = p.tags.find((t) => /^series:/i.test(t));
    return { h: p.handle, u: p.url, i: p.featured_image?.url || p.image, t: p.title.replace(' Shaker Binder Notebook', '').replace(' シャカシャカ手帳', '').trim() || p.title,
      c: p.tags.find((t) => /^(AG|HG)-\d{3}$/.test(t)), s: st && st.slice(7).toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-shaker-binders', pr: Math.round(p.price * 100) };
  };
  function html(q, hits, r) {
    const h = hits.map((it) => ticket(it, OP)).join('');
    return !r ? h : h + group('designs', r.ps.map(row).join('')) +
      group('series', r.cs.map((x) => `<a class="dv-sug__c" href="${esc(x.url)}"${OP}><span class="dv-chip">${N[x.handle]}</span></a>`).join('')) +
      `<a class="dv-sug__all" href="${esc(S.url + '?q=' + encodeURIComponent(q) + '&type=product')}"${OP}>${T.all.replace('%Q%', esc(q))}</a>`;
  }
  function attach(inp) {
    const box = D.getElementById(inp.getAttribute('aria-controls')); if (!box) return;
    let timer = 0, ac = null, seq = 0, act = -1;
    const set = (k, v) => inp.setAttribute(k, v), rm = () => inp.removeAttribute('aria-activedescendant'), opts = () => [...box.querySelectorAll('[role="option"]')];
    'role=combobox aria-autocomplete=list aria-expanded=false'.split(' ').forEach((a) => set(...a.split('=')));
    function show(h) {
      box.innerHTML = h; box.hidden = !h; set('aria-expanded', !!h); act = -1; rm();
      opts().forEach((o, i) => { o.id = box.id + '-' + i; o.tabIndex = -1; });
    }
    function move(d) {
      const o = opts(); if (!o.length) return;
      act = Math.max(-1, Math.min(o.length - 1, act + d));
      o.forEach((x, i) => { x.classList.toggle('is-act', i === act); x.setAttribute('aria-selected', i === act); });
      if (act < 0) rm(); else { set('aria-activedescendant', o[act].id); o[act].scrollIntoView({ block: 'nearest' }); }
    }
    function run() {
      const q = inp.value.trim(), c = cat(), code = c && c.norm(q), my = ++seq; let hits = [], res = null;
      ac?.abort();
      if (q.length < 2 && !code) return show('');
      ac = new AbortController();
      const paint = () => { if (my === seq) show(html(q, hits, res)); };
      // ja → 417, or 429: match catalog titles
      const local = () => (c ? c.get(CFG.allHandle).then((d) => { res = { ps: d.items.filter((it) => (it.t + ' ' + it.c).toLowerCase().includes(q.toLowerCase())).slice(0, 6), cs: [] }; paint(); }, paint) : paint());
      // suggest finds few designs for short words ('cat': 1 of 9) → top up to 6 from the catalog, word-start title match
      const wd = new RegExp('(^|[^a-z0-9])' + q.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
      const fill = () => c && res && res.ps.length < 6 && c.get(CFG.allHandle).then((d) => {
        const seen = new Set(res.ps.flatMap((x) => [x.h, x.c]).filter(Boolean));
        res.ps = res.ps.concat(d.items.filter((it) => !seen.has(it.h) && !seen.has(it.c) && wd.test(it.t)).sort((a, b) => !!b.b - !!a.b)).slice(0, 6); paint();
      }, () => {});
      if (code) c.byCode(q).then((h) => { hits = h; h.length && paint(); }, paint);
      if (dead) return local();
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.sku,tag,vendor', { signal: ac.signal })
        .then((r) => (dead = r.status == 417, r.ok && r.json()))
        .then((r) => { const R = r && r.resources?.results; if (!R) return local(); res = { ps: R.products.map(fromP), cs: R.collections.filter((x) => N[x.handle]) }; paint(); fill(); }, (e) => e.name == 'AbortError' || local());
    }
    inp.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 200); });
    inp.addEventListener('keydown', (e) => {
      const k = e.key, o = opts()[act];
      if (/^Arrow(Up|Down)$/.test(k)) { if (!box.hidden) { e.preventDefault(); move(k === 'ArrowDown' ? 1 : -1); } }
      else if (k === 'Enter') { if (!box.hidden && o) { e.preventDefault(); location.href = o.href; } }
      else if (k === 'Escape') { if (!box.hidden) { e.preventDefault(); e.stopPropagation(); show(''); } }  // list first, then panel
      else if (k === 'Tab') show('');
    });
    D.addEventListener('pointerdown', (e) => { if (e.target !== inp && !box.contains(e.target)) { box.hidden = true; set('aria-expanded', false); } });
  }
  // search page: 1 N° hit → its page, unless Back/reload; till then the grid stays hidden (.is-code), so nothing tappable is yanked away
  const reveal = () => D.querySelector('.dv-search.is-code')?.classList.remove('is-code');
  function lookup() {
    const out = D.querySelector('[data-dv-code-hits]'), c = cat(), q = new URLSearchParams(location.search).get('q');
    if (!(out && c && c.norm(q))) return reveal();
    c.byCode(q).then((hits) => {
      DV.track?.publish('dv_code_lookup', { hit: hits.length, where: 'search' });
      // after onload (4 s cap): a script navigation during load replaces this entry (WebKit, Chrome), and Back must return here;
      // .is-jump keeps the results hidden meanwhile
      let gone = 0; const go = () => gone++ || setTimeout(() => location.assign(hits[0].u));
      if (hits.length === 1 && !/back|reload/.test(performance.getEntriesByType('navigation')[0]?.type)) {
        D.querySelector('.dv-search')?.classList.add('is-jump');
        return D.readyState === 'complete' ? go() : (addEventListener('load', go), setTimeout(go, 4000));
      }
      out.innerHTML = hits.map((it) => ticket(it)).join(''); reveal();
    }, reveal);
  }
  // after dv-catalog.js
  D.addEventListener('DOMContentLoaded', () => { D.querySelectorAll('input[data-dv-suggest]').forEach(attach); lookup(); });
  addEventListener('pageshow', (e) => e.persisted && reveal());  // Back after the jump (bfcache)
})();
